// extracted by mini-css-extract-plugin
module.exports = {"root":"Policies_root__KOIuF","section":"Policies_section__rIfBZ","body":"Policies_body__qwID2","bodyText":"Policies_bodyText__afRXF","title":"Policies_title__Fosta"};